﻿import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKFilter from '@tk/components/tk.filter';
import TKFilterChip from '@tk/components/tk.filter.chip';
import TKFilterResult from '@tk/components/tk.filter.result';
import TKFilterDropdown from '@tk/components/tk.filter.dropdown';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilterGroup from '@tk/components/tk.filter.group';
import TKFilterSearch from '@tk/components/tk.filter.search';
import TKFilterSelectReset from '@tk/components/tk.filter.select.reset';
import TKFilterDrilldownButton from '@tk/components/tk.filter.drilldown.button';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKCompareButton from '@tk/components/tk.compare.button';
import TKCarousel from '@tk/components/tk.carousel';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKFormTimepicker from '@tk/controls/tk.form.timepicker';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKTable from '@tk/components/tk.table';
import TKSelection from '@tk/controls/tk.selection';
import KWArticleList from '@/components/kw.article.list';
import KWStock from '@/components/kw.stock';
import KWPrice from '@/components/kw.price';
import KWTracker from '@/components/kw.tracker';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import KWFileUploadArea from '@/components/kw.file.upload.area';
import KWAsync from '@/components/kw.async';
import KWSectionToggler from '@/components/kw.section.toggler';
import KWDialog from '@/components/kw.dialog';
import KWFormElement from '@/components/kw.form.element';
import KWTourSchedule from '@/components/kw.tour.schedule';
import KWProductVariants from '@/components/kw.product.variants';
import KWTracking from '@/components/kw.tracking';
import KWFavoriteButton from '@/components/kw.favorite.button';
import KWBasketButton from '@/components/kw.basket.button';
import KWFormTracker from '@/components/kw.form.tracker';
import KWScan from '@/components/kw.scan';
import KWSearch from '@/controls/kw.search';
import KWTabsTab from '@/components/kw.tabs.tab';

import 'tippy.js/dist/tippy.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@scss/modules/struct.scss';

export default class Struct extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'kw-tracker', constructor: KWTracker },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'kw-form-tracker', constructor: KWFormTracker },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-search', constructor: KWSearch },
            { name: 'kw-basket-button', constructor: KWBasketButton },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-filter', constructor: TKFilter },
            { name: 'tk-filter-chip', constructor: TKFilterChip },
            { name: 'tk-filter-result', constructor: TKFilterResult },
            { name: 'tk-filter-dropdown', constructor: TKFilterDropdown },
            { name: 'tk-filter-group-wrapper', constructor: TKFilterGroupWrapper },
            { name: 'tk-filter-group', constructor: TKFilterGroup },
            { name: 'tk-filter-search', constructor: TKFilterSearch },
            { name: 'tk-filter-select-reset', constructor: TKFilterSelectReset },
            { name: 'tk-filter-drilldown-button', constructor: TKFilterDrilldownButton },
            { name: 'tk-article-list', constructor: KWArticleList },
            { name: 'tk-price', constructor: KWPrice },
            { name: 'tk-stock', constructor: KWStock },
            { name: 'tk-favorite-button', constructor: KWFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-file-upload-area', constructor: KWFileUploadArea },
            { name: 'kw-async', constructor: KWAsync },
            { name: 'kw-section-toggler', constructor: KWSectionToggler },
            { name: 'tk-form-timepicker', constructor: TKFormTimepicker },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'kw-dialog', constructor: KWDialog },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'kw-form-element', constructor: KWFormElement },
            { name: 'kw-tour-schedule', constructor: KWTourSchedule },
            { name: 'tk-table', constructor: TKTable },
            { name: 'kw-product-variants', constructor: KWProductVariants },
            { name: 'kw-tracking', constructor: KWTracking },
            { name: 'kw-scan', constructor: KWScan },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-tabs-tab', constructor: KWTabsTab },
        ]);
    }
}

new Struct();
